/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserAuthCreateData, UserAuthCreateStatus200, UserAuthCreateStatus400 } from "../types/UserAuthCreate.ts";

function getUserAuthCreateUrl() {
	const res = { method: "POST", url: `/api/user/auth` as const };

	return res;
}

/**
 * @description Авторизация пользователя по ОТП-коду.
 * @summary авторизация по ОТП
 * {@link /api/user/auth}
 */
export async function userAuthCreate(
	data: UserAuthCreateData,
	config: Partial<RequestConfig<UserAuthCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<UserAuthCreateStatus200, ResponseErrorConfig<UserAuthCreateStatus400>, UserAuthCreateData>({
		method: "POST",
		url: getUserAuthCreateUrl().url.toString(),
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
